import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { relativeClausesData, getDataForDifficulty } from '../courses/data/grammar/relativeClauses';

export default function RelativeClauseTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : relativeClausesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
